var _rect, _rect2, _rect3, _mask, _path, _circle, _rect4, _mask2, _path2, _circle2, _rect5, _circle3, _rect6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgListBox = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 260,
  height: 140,
  fill: "none"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 120,
  height: 80,
  x: 70.071,
  y: 29.833,
  fill: "var(--hop-neutral-surface-strong)",
  rx: 8
})), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
  width: 118,
  height: 78,
  x: 68,
  y: 28,
  fill: "var(--hop-neutral-surface)",
  rx: 7
})), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
  width: 118,
  height: 78,
  x: 68,
  y: 28,
  stroke: "var(--hop-neutral-surface-strong)",
  strokeWidth: 2,
  rx: 7
})), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
  id: "ListBox_svg__a",
  fill: "var(--hop-neutral-surface)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M69 31h116v24H69z"
}))), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#E0DFDD",
  d: "M185 54H69v2h116z",
  mask: "url(#ListBox_svg__a)"
})), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 89,
  cy: 43,
  r: 6,
  fill: "var(--hop-neutral-surface-weak)"
})), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
  width: 64,
  height: 4,
  x: 105,
  y: 41,
  fill: "var(--hop-neutral-surface-weak)",
  rx: 2
})), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
  id: "ListBox_svg__b",
  fill: "var(--hop-neutral-surface)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M69 55h116v24H69z"
}))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#E0DFDD",
  d: "M185 78H69v2h116z",
  mask: "url(#ListBox_svg__b)"
})), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
  cx: 89,
  cy: 67,
  r: 6,
  fill: "var(--hop-neutral-surface-weak)"
})), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
  width: 64,
  height: 4,
  x: 105,
  y: 65,
  fill: "var(--hop-neutral-surface-weak)",
  rx: 2
})), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
  cx: 89,
  cy: 91,
  r: 6,
  fill: "var(--hop-neutral-surface-weak)"
})), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
  width: 64,
  height: 4,
  x: 105,
  y: 89,
  fill: "var(--hop-neutral-surface-weak)",
  rx: 2
})));
export default SvgListBox;